import { getLocaleDirection } from '@angular/common';
import { Injectable, Inject, LOCALE_ID } from '@angular/core';
import { DateManagerService } from '@core/services/date-manager/date-manager.service';
import { environment } from 'src/environments/environment';
import { NzI18nService, en_US, he_IL, de_DE, ru_RU } from 'ng-zorro-antd/i18n';

@Injectable({
  providedIn: 'root',
})
export class LanguageService {
  current = this.locale;
  constructor(
    private dateManagerService: DateManagerService,
    @Inject(LOCALE_ID) public locale: string,
  ) {
    this.dateManagerService.setNzi18nServiceLocale(this.setLocale());
  }

  private languageMap: { [key: string]: string } = {
    enUS: '/en-US',
    enUtil: '/en-Util',
    ru: '/ru-RU',
    de: '/de-DE',
    he: '/he-HE', // Add more language codes and their display names
  };

  switchLanguage(newLanguage: string): void {
    let currentPath = window.location.pathname;

    currentPath = this.removePropertiesFromString(currentPath);
    const newPath = `/${newLanguage}${currentPath}`;

    if (environment.production) {
      window.location.href = window.location.origin + newPath;
    }
  }

  getLanguageCodeFromPath(path: string): string {
    const languageCode = Object.keys(this.languageMap).find((key) =>
      path.startsWith(this.languageMap[key]),
    );

    return languageCode || 'enUS';
  }
  getLocaleDirection(): 'right' | 'left' {
    return getLocaleDirection(this.locale)?.toLowerCase() !== 'rtl'
      ? 'right'
      : 'left';
  }
  private removePropertiesFromString(inputString) {
    // Create a regular expression pattern from object property names
    const pattern = new RegExp(Object.values(this.languageMap).join('|'), 'g');

    // Use the pattern to replace matched properties with an empty string
    const result = inputString.replace(pattern, '');

    return result;
  }

  setLocale() {
    switch (this.current) {
      case 'en-US':
        en_US.DatePicker.lang.dateFormat = 'MM/dd/yyyy';
        return en_US;
      case 'he-HE':
        he_IL.DatePicker.lang.dateFormat = 'dd/MM/yyyy';
        he_IL.DatePicker.lang.dateTimeFormat = 'dd/MM/yyyy HH:mm:ss';
        return he_IL;
      case 'de-DE':
        return de_DE;
      case 'ru-RU':
        return ru_RU;
      default:
        return en_US;
    }
  }
}
